import PropTypes from 'prop-types';

import { Announcement, getFormattedLongDate, parseLocalDate, ProgressBar } from '@utilities';

import styles from './_index.module.scss';

const SubscriptionOverviewV2 = ({ subscription }) => {
  if (!subscription) {
    return (
      <div>
        <Announcement
          header="No subscription information available."
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  if (!subscription?.hasStarted) {
    return (
      <div>
        <Announcement
          header={`Great news! Your subscription kicks off ${getFormattedLongDate(parseLocalDate(subscription.startDate))}`}
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  // Calculate next reset date: if subscription end date is after current period end date,
  // the next reset is 1 day after the current period ends
  const currentPeriodEnd = subscription?.currentPeriod?.endDate;
  const hasNextPeriod = subscription?.hasFuturePeriods;

  const nextResetDate = hasNextPeriod
    ? (() => {
        if (!currentPeriodEnd) {
          return null;
        }
        const nextDate = parseLocalDate(currentPeriodEnd);
        nextDate.setDate(nextDate.getDate() + 1);
        return nextDate;
      })()
    : null;

  return (
    <div className={styles['subscription-overview-usage-row-container']}>
      <section className={styles['subscription-overview-usage-row']}>
        <span>Completes</span>
        <span>
          <strong>
            {subscription?.currentPeriod?.usedCompletes?.toLocaleString()} /{' '}
            {subscription?.currentPeriod?.totalCompletes?.toLocaleString()} used
          </strong>
        </span>
      </section>
      <ProgressBar
        className={styles['subscription-overview-bar-neutral']}
        hasError={
          subscription?.currentPeriod?.totalCompletes > 0 &&
          subscription?.currentPeriod?.usedCompletes /
            subscription?.currentPeriod?.totalCompletes >=
            1
        }
        max={subscription?.currentPeriod?.totalCompletes}
        value={subscription?.currentPeriod?.usedCompletes}
      />
      <p className={styles['subscription-overview-remaining']}>
        {(
          subscription?.currentPeriod?.totalCompletes - subscription?.currentPeriod?.usedCompletes
        )?.toLocaleString()}{' '}
        remaining
      </p>
      <ul className={styles['subscription-overview-resets']}>
        <li>
          Period: {getFormattedLongDate(parseLocalDate(subscription?.currentPeriod?.startDate))} -{' '}
          {getFormattedLongDate(parseLocalDate(subscription?.currentPeriod?.endDate))}
        </li>
        {hasNextPeriod && (
          <li>Next reset: {nextResetDate ? getFormattedLongDate(nextResetDate) : 'N/A'}</li>
        )}
      </ul>
    </div>
  );
};

SubscriptionOverviewV2.propTypes = {
  subscription: PropTypes.object,
};

export default SubscriptionOverviewV2;
